import { INDEX_PAGE, SIGN_IN_MODAL } from '@/constants';
import type { Context } from '@nuxt/types';

export default function authUser(ctx: Context) {
  const {
    app: { $utils },
    route: { fullPath },
    $auth,
  } = ctx;

  if (!$auth.loggedIn) {
    $utils.redirectWithQuery(INDEX_PAGE, {
      query: {
        dynamic_modal: SIGN_IN_MODAL,
        ...(fullPath !== '/' && { referer: fullPath }),
      },
    });
  }
}
